"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "../internal/cx.js";
/** A number with an icon: what it means lives in `label` (tooltip + aria), so the line stays short. */
export function Metric({ icon, value, label, short, tone = "neutral", dim, className }) {
    const text = typeof value === "string" || typeof value === "number" ? `${label}: ${value}${short ? ` ${short}` : ""}` : label;
    return _jsxs("span", { className: cx("jui-metric", `jui-tone-${tone}`, dim && "jui-metric--dim", className), title: label, role: "img", "aria-label": text, children: [icon, _jsx("b", { children: value }), short && _jsx("span", { className: "jui-metric-short", children: short })] });
}
